import wig from '../assets/wig.webp';
import curly from '../assets/curly.webp';
import brazil from '../assets/brazil.webp';
import teaching from '../assets/karae.webp';
import eva from '../assets/eva.webp';

export const paragraphs = [
    {
      id: 1,
      primary: `I’m a colour specialist and hairdresser with 
      over 20 years in the game`,
      secondary: `, working across every hair texture, every 
      shade, every style.`,
      image: wig,
      button: 'The Haircare Professional'
    },
    {
      id: 2,
      primary: `Hair is my craft, but education is my purpose. `,
      secondary: ` I run cutting edge courses built for the next
      wave of stylists those who want to break rules the right 
      way.`,
      image: teaching,
      button: 'The Educator'
    },{
      id: 3,
      primary: `My work doesn’t just follow trends it helps 
            create them. `,
      secondary: `From the salon floor to the set, I’ve coloured for 
            major productions like: `,
      image: eva,
      button: "Who i've worked with..."
    },{
      id: 4,
      primary: `I’m all about pushing boundaries and raising
                standards `,
      secondary: `to ensure the future of hairdressing
              is diverse, skilled, and fearless. `,
      image: curly,
      button: 'See Gallery'
    },{
      id: 5,
      primary: `Whether you’re sat in my chair or learning in my
              classroom, you’re getting more than just hair, `,
      secondary: `you’re getting
                experience, vision, and straight-up passion.`,
      image: brazil,
      button: 'Testimonials'
    },
  ];